(function ($) {
  Drupal.behaviors.moisturizer_repromotion_quiz_v1 = {
    attached: false,
    $html: $('html, body'),
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $thismodule = $('.moisturizer-repromote-quiz', context);
      var self = this;

      $thismodule.each(function () {
        var $module = $(this),
          $panelIntro = $module.find('.js-panel-intro'),
          $panelQuiz = $module.find('.js-panel-quiz'),
          $panelResults = $module.find('.js-panel-results'),
          $panelLightbox = $module.find('.js-lightbox-modalbg'),
          $panelQuestionMultichoice = $module.find('.mr-question--multichoice'),
          $btnInitQuiz = $module.find('.js-btn-init-quiz'),
          $btnClose = $module.find('.js-btn-close'),
          $btnRestart = $module.find('.js-btn-restart'),
          $btnCloseResults = $module.find('.js-btn-close-results'),
          $btnBack = $module.find('.js-btn-back'),
          $btnNext = $module.find('.js-btn-next'),
          $quizQuestions = $module.find('.js-quiz-question'),
          $resultsWrapper = $module.find('.js-results-wrapper'),
          $carouselParent = {},
          $instances = [];
        // jQuery sometimes requires just the string for a class (e.g., 'some-class-name') (addClass, removeClass, hasClass)
        // other times it requires the selector (e.g., '.some-class-name') (filter, find)
        // here we use prefixes to distinguish them, 'class' indicates without the dot, 'selector' with the dot
        // just concatenate a dot to the 'class' variable and make it the selector (avoid typos and similar mistakes)
        var classQuizOption = 'js-quiz-option',
          classQuizTrack = 'js-quiz-track',
          classOptionSelected = 'mr-question__option--selected',
          classQuestionIgnored = 'mr-question--ignored',
          classQuestionCurrent = 'mr-question--current',
          classQuestionOption = 'js-quiz-optional',
          classBtnNextActive = 'mr-actions__next--active',
          classMultiChoice = '',
          selectorQuizOption = '.' + classQuizOption,
          selectorOptionSelected = '.' + classOptionSelected,
          selectorQuizTrack = '.' + classQuizTrack,
          selectorQuestionIgnored = '.' + classQuestionIgnored,
          selectorQuestionOption = '.' + classQuestionOption,
          quizComplete,
          Quiz = {
            state: {
              step: 1,
              maxSteps: 5,
              answers: {}
            }
          };

        function startQuiz($btn) {
          $panelIntro.hide();
          $panelQuiz.show();
          showQuestion();
          updateButtons();

          // The quiz can be inserted as a slide in a carousel. These carousels loop to give a continuous effect.
          // Technically this is achieved by duplicating the first slide and placing it at the end of the carousel and
          // taking the last slide and putting it at the beginning. As the user moves beyond the first/last slide the carousel
          // will display the correct "next" slide and then seamlessly move back to the original position.
          // As the quiz has many states - stages/selections etc - these need to be applied to both "instances" of the quiz in the carousel.
          // All carousel code in this JavaScript file is related to this.
          carouselCheck();

          setCarouselInstances();
          updateQuizInstances($btn, true);
          removeCarouselListeners();
          applyIndex();
        }

        function carouselCheck() {
          $carouselParent = $module.closest('.basic_infinite_carouselWrapper');
          if ($carouselParent.length > 0) {
            $carouselParent.closest('.basic_infinite_carousel_v1').addClass('repromote-quiz');
            $carouselParent.siblings('.basic_infinite_carouselnav').addClass('repromote-quiz');
          }
        }

        function resetQuiz() {
          // reset all the questions!!
          for (var step = 0; step < Quiz.state.maxSteps; step++) {
            resetQuestion(step);
          }

          Quiz.state.step = 1;

          $panelResults.hide();
          $panelLightbox.removeClass('mr-lightbox--showing');
          $module.removeClass('moisturizer-repromote-quiz--remove-overflow');
          $panelQuiz.hide();
          $panelIntro.show();

          addCarouselListeners();
          clearAllSelections();
          closeQuizInstances();
          removeIndex();
        }

        function closeResults() {
          $panelIntro.hide();
          $panelResults.hide();
          $panelLightbox.removeClass('mr-lightbox--showing');
          $module.removeClass('moisturizer-repromote-quiz--remove-overflow');
          $panelQuiz.show();
          $resultsWrapper.slick('unslick');
          if (isMobile()) {
            showCarouselArrows();
          }
        }

        function hideCarouselArrows() {
          if ($carouselParent && $carouselParent.length > 0) {
            $carouselParent
              .siblings('.basic_infinite_carouselnav')
              .addClass('repromote-quiz--hiding');
          }
        }

        function showCarouselArrows() {
          if ($carouselParent && $carouselParent.length > 0) {
            $carouselParent
              .siblings('.basic_infinite_carouselnav')
              .removeClass('repromote-quiz--hiding');
          }
        }

        function checkResults() {
          var results;

          // check if the moisturizer results formatter is included in Drupal.behaviors so we can call it's stageGetResults method
          if ('mr_quiz_results_formatter_v1' in Drupal.behaviors) {
            results = Drupal.behaviors.mr_quiz_results_formatter_v1.stageGetResults(
              Quiz.state.answers
            );
            if (results) {
              $btnNext.text($btnNext.data('text-show-results'));
              quizComplete = true;
            } else {
              quizComplete = false;
            }
          }
        }

        function moveTop() {
          self.$html.animate(
            {
              scrollTop: $module.offset().top
            },
            500
          );
        }

        function showResults() {
          var results;

          // check if the moisturizer results formatter is included in Drupal.behaviors so we can call it's getResults method
          if ('mr_quiz_results_formatter_v1' in Drupal.behaviors) {
            results = Drupal.behaviors.mr_quiz_results_formatter_v1.getResults(Quiz.state.answers);
            if (results) {
              if (isMobile()) {
                $panelIntro.hide();
                $panelQuiz.hide();
                hideCarouselArrows();
                moveTop();
              }
              $panelResults.show();
              $panelLightbox.addClass('mr-lightbox--showing');
              $module.addClass('moisturizer-repromote-quiz--remove-overflow');
              $resultsWrapper.html(results);
              $resultsWrapper.slick();
              $(document).trigger('Quizresult', [{ results: results }]);
            }
          }
        }

        function previousQuestion(_this) {
          if (Quiz.state.step === 1) {
            return;
          }

          // when going back, reset the current question and the ones after
          for (var step = Quiz.state.step; step <= Quiz.state.maxSteps; step++) {
            resetQuestion(step - 1);
          }
          Quiz.state.step--;
          hideCurrentQuestion();
          showQuestion();
          updateButtons();
          updateQuizInstances(_this, false, true);
        }

        // Once the quiz is closed/reset. Reintroduce the carousel listeners.
        function addCarouselListeners() {
          if (isMobile()) {
            if ($carouselParent.length > 0) {
              var $basicInfiniteCarouselContainer = $carouselParent.closest(
                '.basic_infinite_carouselContainer'
              );

              $basicInfiniteCarouselContainer.swiperight(function () {
                $carouselParent.siblings('.basic_infinite_carouselnav_1').trigger('click');
              });
              $basicInfiniteCarouselContainer.swipeleft(function () {
                $carouselParent.siblings('.basic_infinite_carouselnav_2').trigger('click');
              });
            }
          }
        }

        // remove listeners for carousel on mobile. Once the quiz starts it overrides the carousel
        function removeCarouselListeners() {
          if ($carouselParent.length > 0) {
            if (isMobile()) {
              $carouselParent
                .closest('.basic_infinite_carouselContainer')
                .unbind('swiperight swipeleft');
            }
          }
        }

        function nextQuestion(_this) {
          // don't go through if no option selected
          if (_this.hasClass(classBtnNextActive) === false) {
            return;
          }

          // if last step, show results
          if (quizComplete || Quiz.state.step === Quiz.state.maxSteps) {
            showResults();

            return;
          } else {
            // check remaining results
            checkStageResults();
          }

          hideCurrentQuestion();
          Quiz.state.step++;
          showQuestion();
          updateButtons();

          updateQuizInstances(_this);
        }

        function checkStageResults() {
          if ('mr_quiz_results_formatter_v1' in Drupal.behaviors) {
            var results = Drupal.behaviors.mr_quiz_results_formatter_v1.stageGetResults(
              Quiz.state.answers
            );

            if (results) {
              if (isMobile()) {
                $panelIntro.hide();
                $panelQuiz.hide();
                hideCarouselArrows();
              }
              $panelResults.show();
              $panelLightbox.addClass('mr-lightbox--showing');
              $module.addClass('moisturizer-repromote-quiz--remove-overflow');

              $resultsWrapper.html(results);
              $resultsWrapper.slick();
            }
          }
        }

        function applyInstancesButtonConfigurations($instanceBackButton, $instanceNextButton) {
          // next button text
          if (Quiz.state.maxSteps === Quiz.state.step) {
            $instanceNextButton.text($instanceNextButton.data('text-show-results'));
          } else {
            $instanceNextButton.text($instanceNextButton.data('text-next'));
          }
          // back button
          $instanceBackButton.toggle(Quiz.state.step > 1);
        }

        function applyInstanceCurrentQuestion($instanceCurrentQuestion) {
          $instanceCurrentQuestion.siblings().removeClass('mr-question--current');
          $instanceCurrentQuestion.addClass('mr-question--current');
        }

        function clearMultiChoice($instanceMrQuiz) {
          $instanceMrQuiz.find('.mr-quiz__track').hide();
        }

        function applyInstanceCurrentSelections($instance, currentQuestionTitleClass) {
          var $instanceMrIntro = $instance.find('.mr-intro.js-panel-intro'),
            $instanceMrQuiz = $instance.find('.mr-quiz.js-panel-quiz'),
            $instanceBackButton = $instance.find('.js-btn-back'),
            $instanceNextButton = $instance.find('.js-btn-next'),
            $instanceQuizQuestion = $instance.find(currentQuestionTitleClass);
          var $instanceCurrentQuestion = $instanceQuizQuestion.parent();

          $instanceNextButton.removeClass(classBtnNextActive);

          $instanceMrIntro.hide();
          $instanceMrQuiz.show();

          applyInstanceCurrentQuestion($instanceCurrentQuestion);
          // multichoice
          if (Quiz.state.step === 3 && classMultiChoice !== '') {
            clearMultiChoice($instanceMrQuiz);
            var $instanceCurrentMultiChoice = $instanceMrQuiz.find(
              '.' + classMultiChoice.replace(/\s+/g, '.')
            );

            if ($instanceCurrentMultiChoice.length > 0) {
              $instanceCurrentMultiChoice.show();
            }
          }
          applyInstancesButtonConfigurations($instanceBackButton, $instanceNextButton);
        }

        // Update any instances of the quiz to all the states that the engaged quiz has
        function updateQuizInstances(caller, isStart, isPrevious) {
          if ($carouselParent.length > 0) {
            var $currentQuestion;

            if (caller && isStart) {
              $currentQuestion = caller
                .closest('.mr-intro')
                .siblings('.mr-quiz')
                .find('.mr-questions')
                .find('.mr-question--current');
            } else if (caller) {
              $currentQuestion = caller
                .closest('.mr-actions')
                .siblings('.mr-questions')
                .find('.mr-question--current');
            }
            var $currentQuestionTitle = $currentQuestion.children('.mr-question__question'),
              currentQuestionTitleClass =
                '.' + $currentQuestionTitle.attr('class').replace(/\s+/g, '.');

            $.each($instances, function (instaIndex, instaValue) {
              var $instance = $(instaValue);

              applyInstanceCurrentSelections($instance, currentQuestionTitleClass);

              var $instanceNextButton = $instance.find('.js-btn-next');

              if (!isStart && isPrevious) {
                $instanceNextButton.addClass(classBtnNextActive);
              }
            });
          }
        }

        function isMobile() {
          return $(window).width() < 768;
        }

        // For mobile, we want the quiz to take over the carouel. Increasing the z-index to achieve this
        function applyIndex() {
          if (isMobile()) {
            $($module.addClass('moisturizer-repromote-quiz--apply-index'));
          }
        }

        // Closing the quiz and reducing the z-index back to its original state.
        function removeIndex() {
          if (isMobile()) {
            $($module.removeClass('moisturizer-repromote-quiz--apply-index'));
          }
        }

        function getCurrentQuestion() {
          return getQuestion(Quiz.state.step - 1);
        }

        function getQuestion(questionIndex) {
          return $quizQuestions.eq(questionIndex);
        }

        function hideCurrentQuestion() {
          hideQuestion(Quiz.state.step - 1);
        }

        function hideQuestion(questionIndex) {
          $quizQuestions.eq(questionIndex).removeClass(classQuestionCurrent);
        }

        function showQuestion() {
          $quizQuestions
            .removeClass(classQuestionCurrent)
            .eq(Quiz.state.step - 1)
            .addClass(classQuestionCurrent); // step - 1 === question index in the dom
        }

        function resetQuestion(questionIndex) {
          var $question = getQuestion(questionIndex);

          $question.find(selectorQuizOption).removeClass(classOptionSelected);
          setQuestionAnswer($question.data('question-key'), null);
        }

        function setQuestionAnswer(questionKey, value) {
          Quiz.state.answers[questionKey] = value;
        }

        function getQuestionAnswer(questionKey) {
          return Quiz.state.answers[questionKey];
        }

        // set the carousel quiz instances
        function setCarouselInstances() {
          $instances = $carouselParent.find('.moisturizer-repromote-quiz');
        }

        function clearSelection($selections) {
          $.each($selections, function (selectionIndex, selectionValue) {
            var $selectionValue = $(selectionValue);

            $selectionValue.removeClass('mr-question__option--selected');
          });
        }

        function clearAllSelections() {
          if ($instances && $instances.length > 0) {
            $.each($instances, function (instaIndex, instaValue) {
              var $instance = $(instaValue);
              var $selections = $instance.find('.mr-question__option--selected');

              if ($selections && $selections.length > 0) {
                clearSelection($selections);
              }
            });
          }
        }

        function closeQuizInstances() {
          if ($carouselParent.length > 0) {
            $.each($instances, function (instaIndex, instaValue) {
              var $instance = $(instaValue);

              $instance.find('.mr-intro.js-panel-intro').show();
              $instance.find('.mr-quiz.js-panel-quiz').hide();
            });
          }
        }

        function updateInstanceQuestionOptions(optionValue) {
          if ($instances && $instances.length > 0) {
            $.each($instances, function (instaIndex, instaValue) {
              var $instance = $(instaValue);
              var $currentOption = $instance.find(
                '.mr-question__option[data-value="' + optionValue + '"]'
              );
              var $nextBtn = $instance.find('.mr-actions__next');

              $nextBtn.addClass(classBtnNextActive);
              if ($currentOption.length > 0) {
                $currentOption.siblings().removeClass('mr-question__option--selected');
                $currentOption.addClass('mr-question__option--selected');
              }
            });
          }
        }

        function updateButtons() {
          var $currentQuestion = getCurrentQuestion();

          // next button text
          if (Quiz.state.maxSteps === Quiz.state.step) {
            $btnNext.text($btnNext.data('text-show-results'));
          } else {
            $btnNext.text($btnNext.data('text-next'));
          }

          // next button status
          if ($currentQuestion.find(selectorQuizOption + selectorOptionSelected).length > 0) {
            checkResults();
            $btnNext.addClass(classBtnNextActive);
          } else {
            $btnNext.removeClass(classBtnNextActive);
          }

          // back button
          $btnBack.toggle(Quiz.state.step > 1);
        }

        function updateQuestions() {
          $quizQuestions.each(updateQuestion);
          Quiz.state.maxSteps = $quizQuestions.not(selectorQuestionIgnored).length;
        }

        function updateQuestion(questionIndex) {
          updateQuestionQuery(questionIndex);
          updateQuestionAlternateQuery(questionIndex);
          updateDepandantData(questionIndex);
          hideOptionalData(questionIndex);
        }

        function updateQuestionQuery(questionIndex) {
          var $question = getQuestion(questionIndex);
          var questionKey, questionValue, neededValue;

          // data-if-question/data-if-value (see q5)
          // a question tagged with these is only displayed if the value in data-if-value matches
          // the value for the question in data-if-question
          questionKey = $question.data('if-question');
          if (questionKey || questionKey === false) {
            questionValue = getQuestionAnswer(questionKey);
            neededValue = _stringToArray($question.data('if-value'));
            if (neededValue.indexOf(questionValue) > -1) {
              $question.removeClass(classQuestionIgnored);
            } else {
              $question.addClass(classQuestionIgnored);
              resetQuestion(questionIndex);
            }
            resetMultipleChoiceClasses(questionValue);
          }
        }

        function updateQuestionAlternateQuery(questionIndex) {
          var $question = getQuestion(questionIndex);
          var questionKey, questionValue, neededValue;

          questionKey = $question.data('if-alternative-question');
          if (questionKey || questionKey === false) {
            questionValue = getQuestionAnswer(questionKey);
            neededValue = _stringToArray($question.data('if-alternative-value'));
            if (neededValue.indexOf(questionValue) > -1) {
              $question.addClass(classQuestionIgnored);
              resetQuestion(questionIndex);
            }
          }
        }

        function updateDepandantData(questionIndex) {
          var $question = getQuestion(questionIndex);
          var questionKey, questionValue;

          // data-depends-question/data-depends-value (see q3)
          // a question with data-depends-question, will use the value selected on that question to hide/show dom
          // children that have a data-depends-value with a value that matches it
          questionKey = $question.data('depends-question');
          if (questionKey || questionKey === false) {
            questionValue = getQuestionAnswer(questionKey);
            var $currentMultiChoice = $question
              .find(selectorQuizTrack)
              .hide()
              .filter(function () {
                return $(this).data('depends-value') === questionValue;
              });

            classMultiChoice = $currentMultiChoice[0].className;
            $currentMultiChoice.show();
          }
        }

        function hideOptionalData(questionIndex) {
          var $question = getQuestion(questionIndex);
          var questionKey, questionValue;

          // data-option-question/data-option-value (see q3)
          // a question with data-option-question, will use the value selected on that question to hide dom
          // answer that have a data-option-value with a value that matches it. Hide option with matching value.
          questionKey = $question.data('option-question');
          if (questionKey || questionKey === false) {
            questionValue = getQuestionAnswer(questionKey);
            if (!questionValue || questionValue.length === 0) {
              return;
            }
            var $currentMultiChoice = $question
              .find(selectorQuestionOption)
              .show()
              .filter(function () {
                return $(this).data('option-value') === questionValue;
              });

            if ($currentMultiChoice) {
              $currentMultiChoice.hide();
            }
          }
        }

        // Pixel Perfect related. Need to distiguish between the multiple choice answer option set.
        function resetMultipleChoiceClasses(questionValue) {
          if ($panelQuestionMultichoice.hasClass('mr-question--current')) {
            $panelQuestionMultichoice
              .removeClass()
              .addClass(
                'mr-question js-quiz-question mr-question--multichoice mr-question--current mr-question--' +
                  questionValue
              );
          } else {
            $panelQuestionMultichoice
              .removeClass()
              .addClass(
                'mr-question js-quiz-question mr-question--multichoice mr-question--' +
                  questionValue
              );
          }
        }

        function _stringToArray(theString, separator) {
          var _separator = separator || ',',
            theArray = [];

          if (theString && typeof theString === 'string') {
            if (theString.indexOf(_separator) > -1) {
              theArray = theString.split(_separator);
            } else {
              theArray.push(theString);
            }
          }

          return theArray;
        }

        // Events
        $btnInitQuiz.on('click', function () {
          startQuiz($(this));
        });

        // Main Quiz Close
        $btnClose.on('click', resetQuiz);
        // Start Over
        $btnRestart.on('click', function () {
          closeResults();
          resetQuiz();
        });
        // Close Results
        $btnCloseResults.on('click', closeResults);

        $btnBack.on('click', function () {
          previousQuestion($(this));
        });
        $btnNext.on('click', function () {
          nextQuestion($(this));
        });

        $quizQuestions.on('click', selectorQuizOption, function (event) {
          var $question = $(event.delegateTarget);
          var $option = $(event.currentTarget);

          // remove selected class from all options
          $question.find(selectorQuizOption).removeClass(classOptionSelected);
          $option.addClass(classOptionSelected);

          updateInstanceQuestionOptions($option.attr('data-value'));

          setQuestionAnswer($question.data('question-key'), $option.data('value'));

          updateQuestions();
          updateButtons();
        });
      });
    }
  };
})(jQuery);
